export const environment = {
  production: true,
  buildId: '3997765095024301',
  configFile: 'config.json',
};
